<template>
  <div class="contract-data container col-5 col-mx-auto">
    <div class="patient-name">
      <span class="text-bold">Nombre del paciente</span>
      {{name}}
    </div>
    <div class="home-address">
      <span class="text-bold">Dirección</span>
      {{homeAddress}}
    </div>
    <div class="registry-date">
      <span class="text-bold">Fecha de registro</span>
      {{registryDate}}
    </div>
    <div class="wallet-data">
              <span class="text-bold">Billetero</span>
      {{wallet}}
    </div>
  </div>
</template>


<script>
import PatientsManager from "../managers/patientsManager";
export default {
  data() {
    return {
      name: "",
      homeAddress: "",
      wallet: "",
      registryDate: ""
    };
  },
  async created() {
    console.log(this.$route);
    var contract = await PatientsManager.GetContract(this.$route.params.id);
    var msg = await contract.methods.getName();
    msg.call((i, val) => {
      this.name = val;
    });
    msg = await contract.methods.getHomeAddress();
    msg.call((i, val) => {
      this.homeAddress = val;
    });
    msg = await contract.methods.getDate();
    msg.call((i, val) => {
      let date = new Date();
      date.setTime(val);
      this.registryDate = date.toLocaleString();
    });

    msg = await contract.methods.getWallet();
    msg.call((i, val) => {
        this.wallet = val
    })
  }
};
</script>

<style lang="scss" scoped>
.contract-data {
  background-color: white;
  padding: 15px;
}
span {
    display: block;
    font-size: 1.2em;
}
</style>